import clsx from 'clsx'
import React, { ComponentProps } from 'react'

import { ImageWithPins } from '@Components/Image'
import { Button } from '@CoreComponents/Buttons/Button'
import { PagePresentation } from '@Generated/graphql'
import { Image, ImagePin } from '@Globals/Image'
import { useTranslation } from '@Globals/Translations'

import styles from './TilesCard.module.scss'

export const TilesCardLook = ({
  ambassadorHandle,
  buttonLabel,
  cardAspectRatio,
  cardSize,
  cardVariant,
  image,
  pins,
  presentation = PagePresentation.Full,
  sizes,
  ...props
}: {
  ambassadorHandle?: string
  buttonLabel?: string
  cardAspectRatio: string
  cardSize: string
  cardVariant: string
  image: Image
  pins?: ImagePin[] | null
  presentation?: PagePresentation
  sizes?: string
} & ComponentProps<'div'>) => {
  const { t } = useTranslation()

  return (
    <div
      className={clsx(
        // styles.card,
        styles.look,
        styles[cardVariant],
        styles[cardSize],
        styles[cardAspectRatio],
        styles[presentation.toLowerCase()],
      )}
      {...props}
    >
      <ImageWithPins image={image} pins={pins} sizes={sizes} />
      <div className={styles.content}>
        {ambassadorHandle && (
          <div className={styles.ambassadorHandle}>
            {ambassadorHandle}
          </div>
        )}
        {(buttonLabel || !pins || pins.length === 0) && (
          <div className={styles.buttonContainer}>
            <Button
              className={styles.button}
              innerSpacing="medium"
              theme="white"
              type="button"
            >
              {buttonLabel || t('common:SHOP_THE_LOOK')}
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}
